import React from 'react';
import _ from 'lodash';
import { Tooltip } from 'antd';
import moment from 'moment';

// const copyToClipboard = (str) => {
//   const el = document.createElement('textarea');
//   el.value = str;
//   el.setAttribute('readonly', '');
//   el.style.position = 'absolute';
//   el.style.left = '-9999px';
//   document.body.appendChild(el);
//   el.select();
//   document.execCommand('copy');
//   document.body.removeChild(el);
// };

export const IMAGE_STATUSES = {
  identical: 'IDENTICAL',
  pending: 'PENDING',
  offline: 'OFFLINE',
  duplicate: 'DUPLICATE',
  legitimate: 'LEGITIMATE',
  notPursuable: 'NOT_PURSUABLE',
  nonIdentical: 'NOT_IDENTICAL'
};

export const FILTER_DOMAINS_TABLE_COLUMNS = [
  {
    originTitle: 'ID',
    dataIndex: 'id',
    fieldKey: 'ID',
    customSorted: true,
    fixed: 'left',
    // sorter: (a, b) => {
    //   return a.id - b.id
    // },
    width: '20'
  },
  {
    originTitle: 'Domain Created at',
    dataIndex: 'createdAt',
    fieldKey: 'CREATED_AT',
    customSorted: true,
    render: (date) =>
      !_.isNil(date) ? date.split('.').shift().split('T').join(' ') : ''
    // sorter: (a, b) => {
    //   return a.createdAt.localeCompare(b.createdAt)
    // },
    // width: '40%',
  },
  {
    originTitle: 'Domain Updated at',
    dataIndex: 'updatedAt',
    fieldKey: 'UPDATED_AT',
    customSorted: true,
    render: (date) =>
      !_.isNil(date) ? date.split('.').shift().split('T').join(' ') : ''
    // sorter: (a, b) => {
    //   return a.updatedAt.localeCompare(b.updatedAt)
    // },
    // width: '40%',
  },
  {
    originTitle: 'Domain Updated by',
    dataIndex: 'updatedBy',
    fieldKey: 'UPDATED_BY',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Domain',
    dataIndex: 'domain',
    fieldKey: 'DOMAIN',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Domain Filled by operator',
    dataIndex: 'filledByOperator',
    fieldKey: 'FILLED_BY_OPERATOR',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Priority Language',
    dataIndex: 'priorityLanguage',
    fieldKey: 'PRIORITY_LANGUAGE',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Other Language',
    dataIndex: 'otherLanguage',
    fieldKey: 'OTHER_LANGUAGE',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Priority Country',
    dataIndex: 'priorityCountry',
    fieldKey: 'PRIORITY_COUNTRY',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Other Countries',
    dataIndex: 'otherCountries',
    fieldKey: 'OTHER_COUNTRIES',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Commercial Website',
    dataIndex: 'commercialWebSite',
    fieldKey: 'COMMERCIAL_WEB_SITE',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Country of contact',
    dataIndex: 'countryOfContact',
    fieldKey: 'COUNTRY_OF_CONTACT',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Postcode',
    dataIndex: 'postcode',
    fieldKey: 'POSTCODE',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'City',
    dataIndex: 'city',
    fieldKey: 'CITY',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Street',
    dataIndex: 'street',
    fieldKey: 'STREET',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Email',
    dataIndex: 'email',
    fieldKey: 'EMAIL',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Phone number',
    dataIndex: 'phoneNumber',
    fieldKey: 'PHONE_NUMBER',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Contact Form Link',
    dataIndex: 'contactFormLink',
    fieldKey: 'CONTACT_FORM_LINK',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Facebook link',
    dataIndex: 'facebookLink',
    fieldKey: 'FACEBOOK_LINK',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Priority',
    dataIndex: 'priority',
    fieldKey: 'PRIORITY',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Comment',
    dataIndex: 'comment',
    fieldKey: 'COMMENT',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Instagram Link',
    dataIndex: 'instagramLink',
    fieldKey: 'INSTAGRAM_LINK',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Linkedin Link',
    dataIndex: 'linkedinLink',
    fieldKey: 'LINKEDIN_LINK',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Twitter Link',
    dataIndex: 'twitterLink',
    fieldKey: 'TWITTER_LINK',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Company Name',
    dataIndex: 'companyName',
    fieldKey: 'COMPANY_NAME',
    customSorted: true
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Blacklisted',
    dataIndex: 'blacklisted',
    fieldKey: 'BLACKLISTED',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  // {
  //   originTitle: 'MultiLanguage',
  //   dataIndex: 'multiLanguage',
  //   fieldKey: 'MULTILANGUAGE',
  //   customSorted: true,
  //   render: text => (
  //     !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
  //   ),
  //   // sorter: (a, b) => { return a.name.localeCompare(b.name)},
  //   // width: '40%',
  // },
  {
    originTitle: 'MultiNational',
    dataIndex: 'multiNational',
    fieldKey: 'MULTI_NATIONAL',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'No Country Identified',
    dataIndex: 'noCountryIdentified',
    fieldKey: 'NO_COUNTRY_IDENTIFIED',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'No Details Found',
    dataIndex: 'noDetailsFound',
    fieldKey: 'NO_DETAILS_FOUND',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'No Language Identified',
    dataIndex: 'noLanguageIdentified',
    fieldKey: 'NO_LANGUAGE_IDENTIFIED',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  },
  {
    originTitle: 'Unsure Type',
    dataIndex: 'unsureType',
    fieldKey: 'UNSURE_TYPE',
    customSorted: true,
    render: (text) =>
      !_.isNil(text) ? <span>{text.toString()}</span> : <span>false</span>
    // sorter: (a, b) => { return a.name.localeCompare(b.name)},
    // width: '40%',
  }
];

export const IMAGES_TABLE_COLUMNS = [
  {
    originTitle: 'Domain',
    dataIndex: 'domain',
    fieldKey: 'DOMAIN',
    align: 'center',
    customSorted: true,
    width: '12%'
  },
  {
    originTitle: 'Country',
    dataIndex: 'country',
    fieldKey: 'country',
    align: 'center',
    customSorted: true,
    render: (country) =>
      country[0] === '-' ? (
        country[0]
      ) : (
        <Tooltip title={country[0].fullName}>{country[0].alpha3Code}</Tooltip>
      ),
    width: '11%'
  },
  {
    originTitle: 'Total sightings',
    dataIndex: 'sightingsCount',
    fieldKey: 'SIGHTINGS_COUNT',
    align: 'center',
    customSorted: true,
    width: '9%'
  },
  {
    originTitle: 'Identical sightings',
    dataIndex: 'identicalSightingsCount',
    fieldKey: 'IDENTICAL_SIGHTINGS_COUNT',
    align: 'center',
    customSorted: true,
    width: '9%'
  },
  {
    originTitle: (
      <>
        Sightings <br />
        of image
      </>
    ),
    dataIndex: 'searchedImageCount',
    fieldKey: 'SEARCHED_IMAGE_COUNT',
    align: 'center',
    customSorted: true,
    width: '9%'
  },
  {
    originTitle: 'Identical sightings of image',
    dataIndex: 'searchedImageIdenticalCount',
    fieldKey: 'SEARCHED_IMAGE_IDENTICAL_COUNT',
    align: 'center',
    customSorted: true,
    width: '11%'
  },
  {
    originTitle: (
      <>
        Domain <br />
        status
      </>
    ),
    dataIndex: 'domainFlowStatus',
    fieldKey: 'DOMAIN_FLOW_STATUS',
    align: 'center',
    customSorted: true,
    render: (status) => (
      <Tooltip title={status[0].fullName}>{status[0].shortName}</Tooltip>
    ),
    width: '10%'
  },
  {
    originTitle: 'Commercial',
    dataIndex: 'commercialIcon',
    fieldKey: 'COMMERCIAL_WEB_SITE',
    align: 'center',
    customSorted: true,
    width: '10%'
  },
  {
    originTitle: 'Pursuable',
    dataIndex: 'pursuableIcon',
    fieldKey: 'NOT_PURSUABLE',
    align: 'center',
    customSorted: true,
    width: '9%'
  },
  {
    originTitle: (
      <>
        Not <br />
        blacklisted
      </>
    ),
    dataIndex: 'blacklistedIcon',
    fieldKey: 'BLACKLISTED',
    align: 'center',
    customSorted: true,
    width: '10%'
  }
];

export const DOMAINS_TABLE_COLUMNS = [
  {
    originTitle: 'Domain',
    dataIndex: 'domain',
    fieldKey: 'DOMAIN',
    align: 'center',
    customSorted: true,
    width: '15%'
  },
  {
    originTitle: 'Country',
    dataIndex: 'country',
    fieldKey: 'country',
    align: 'center',
    customSorted: true,
    render: (country) =>
      country[0] === '-' ? (
        country[0]
      ) : (
        <Tooltip title={country[0]?.fullName}>{country[0]?.alpha3Code}</Tooltip>
      ),
    width: '15%'
  },
  {
    originTitle: 'Non Verified Country',
    dataIndex: 'scrapedCountry',
    fieldKey: 'SCRAPED_COUNTRY',
    align: 'center',
    customSorted: true,
    render: (scrapedCountry) => {
      return (
        <>
          {scrapedCountry[0] === '-' ? (
            scrapedCountry[0]
          ) : (
            <>
              {scrapedCountry[0] && (
                <Tooltip title={scrapedCountry[0]?.fullName}>
                  {scrapedCountry[0]?.alpha3Code}
                </Tooltip>
              )}
            </>
          )}
        </>
      );
    },
    width: '15%'
  },
  {
    originTitle: 'Total sightings',
    dataIndex: 'sightingsCount',
    fieldKey: 'SIGHTINGS_COUNT',
    align: 'center',
    customSorted: true,
    width: '10%'
  },
  {
    originTitle: 'Identical sightings',
    dataIndex: 'identicalSightingsCount',
    fieldKey: 'IDENTICAL_SIGHTINGS_COUNT',
    align: 'center',
    customSorted: true,
    width: '10%'
  },
  {
    originTitle: 'Domain status',
    dataIndex: 'domainFlowStatus',
    fieldKey: 'DOMAIN_FLOW_STATUS',
    align: 'center',
    customSorted: true,
    render: (status) => (
      <Tooltip title={status[0]?.fullName}>{status[0]?.shortName}</Tooltip>
    ),
    width: '15%'
  },
  {
    originTitle: 'Commercial',
    dataIndex: 'commercialIcon',
    fieldKey: 'COMMERCIAL_WEB_SITE',
    align: 'center',
    customSorted: true,
    width: '12%'
  },
  {
    originTitle: 'Pursuable',
    dataIndex: 'pursuableIcon',
    fieldKey: 'NOT_PURSUABLE',
    align: 'center',
    customSorted: true,
    width: '11%'
  },
  {
    originTitle: 'Not blacklisted',
    dataIndex: 'blacklistedIcon',
    fieldKey: 'BLACKLISTED',
    align: 'center',
    customSorted: true,
    width: '12%'
  }
];

export const USAGE_URL_TABLE_COLUMNS = [
  {
    originTitle: 'Status',
    dataIndex: 'status',
    fieldKey: 'STATUS',
    align: 'center',
    // customSorted: true,
    width: '6%'
  },
  {
    originTitle: 'Agency',
    dataIndex: 'agency',
    fieldKey: 'AGENCY',
    align: 'center',
    // customSorted: true,
    width: '5%',
    render: (agency) => (
      <div>
        <strong>{agency}</strong>
      </div>
    )
  },
  {
    originTitle: 'Country',
    dataIndex: 'country',
    fieldKey: 'country',
    align: 'center',
    // customSorted: true,
    render: (country) =>
      country[0] === '-' ? (
        country[0]
      ) : (
        <Tooltip title={country[0]?.fullName}>{country[0]?.alpha3Code}</Tooltip>
      ),
    width: '8%'
  },
  {
    originTitle: 'Non Verified Country',
    dataIndex: 'scrapedCountry',
    fieldKey: 'scrapedCountry',
    align: 'center',
    // customSorted: true,
    render: (scrapedCountry) => {
      return (
        <>
          {scrapedCountry[0] === '-' ? (
            scrapedCountry[0]
          ) : (
            <>
              {scrapedCountry[0] && (
                <Tooltip title={scrapedCountry[0]?.fullName}>
                  {scrapedCountry[0]?.alpha3Code}
                </Tooltip>
              )}
            </>
          )}
        </>
      );
    },
    width: '8%'
  },
  {
    originTitle: 'Image Id',
    dataIndex: 'imageId',
    fieldKey: 'IMAGE_ID',
    align: 'center',
    // customSorted: true,
    width: '7%',
    render: (imageId) => (
      <div>
        <strong>{imageId}</strong>
      </div>
    )
  },
  {
    originTitle: 'Image Url',
    dataIndex: 'imageUrl',
    fieldKey: 'IMAGE_URL',
    align: 'center',
    // customSorted: true,
    width: '40%',
    minWidth: '350px'
  },
  {
    originTitle: 'Domain',
    dataIndex: 'domain',
    fieldKey: 'DOMAIN',
    align: 'center',
    // customSorted: true,
    width: '8%',
    render: (url) => (
      <p
        className='usageUrl'
        onClick={() => window.open(`https://${url}`).focus()}
      >
        {url}
      </p>
    )
  },
  {
    originTitle: 'Usage Url',
    dataIndex: 'usageUrl',
    fieldKey: 'USAGE_URL',
    align: 'center',
    // customSorted: true,
    width: '10%',
    render: (url) => (
      <p className='usageUrl' onClick={() => window.open(url).focus()}>
        {url}
      </p>
    )
  },
  {
    originTitle: 'Found At',
    dataIndex: 'foundAt',
    fieldKey: 'FOUND_AT',
    align: 'center',
    // customSorted: true,
    width: '8%',
    render: (foundAt) => (
      <div>{moment(foundAt).format('MMMM Do YYYY, h:mm:ss a')}</div>
    )
  },
  {
    originTitle: 'Difference',
    dataIndex: 'difference',
    fieldKey: 'DIFFERENCE',
    align: 'center',
    // customSorted: true,
    width: '6%'
  },
  {
    originTitle: 'Pursuable',
    dataIndex: 'pursuableIcon',
    fieldKey: 'NOT_PURSUABLE',
    align: 'center',
    width: '4%'
  },
  {
    originTitle: 'Not blacklisted',
    dataIndex: 'blacklistedIcon',
    fieldKey: 'BLACKLISTED',
    align: 'center',
    customSorted: true,
    width: '2%'
  }
];

export const BLACKLISTED_TABLE_COLUMNS = [
  {
    originTitle: 'Domain',
    dataIndex: 'domain',
    fieldKey: 'DOMAIN',
    customSorted: true
  },
  {
    originTitle: 'Actions',
    dataIndex: 'editButton',
    fieldKey: 'EDIT_BUTTON',
    customSorted: false,
    align: 'center',
    width: '10%'
  }
];

export const FIELD_QUERY_TYPES = {
  number: {
    IS_NOT_NULL: null,
    IS_NULL: null,
    BETWEEN: 'doubleInput',
    EQ: 'input',
    LOE: 'input',
    GT: 'input',
    NOT_IN: 'textarea',
    IN: 'textarea'
  },
  date: {
    IS_NOT_NULL: null,
    IS_NULL: null,
    BETWEEN: 'dateRange',
    EQ: 'datePicker',
    LOE: 'datePicker',
    GT: 'datePicker'
  },
  string: {
    IS_NOT_NULL: null,
    IS_NULL: null,
    LIKE: 'input',
    EQ: 'input',
    IN: 'textarea',
    NOT_IN: 'textarea'
  },
  status: {
    IS_NOT_NULL: null,
    IS_NULL: null,
    LIKE: 'input',
    EQ: 'dropdownStatus',
    IN: 'dropdownStatusMulti',
    NOT_IN: 'dropdownStatusMulti'
  },
  boolean: {
    IS_NOT_NULL: null,
    IS_NULL: null,
    IS_TRUE: null,
    IS_FALSE: null
  },
  checkbox: {}
};

export const BLACKLISTED_TABLE_FIELDS_FILTER = {
  ID: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number',
    visibility: false
  },
  DOMAIN: {
    selectorTypes: ['EQ'],
    componentType: 'string',
    visibility: true
  },
  EDIT_BUTTON: {
    selectorTypes: ['EQ'],
    componentType: 'string',
    visibility: false
  }
};

export const DOMAINS_TABLE_FIELDS_FILTER = {
  ID: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number'
  },
  DOMAIN: {
    selectorTypes: ['LIKE', 'IN', 'EQ', 'IS_NOT_NULL', 'IS_NULL', 'NOT_IN'],
    componentType: 'string'
  },
  CREATED_AT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'BETWEEN', 'EQ', 'LOE', 'GT'],
    componentType: 'date'
  },
  UPDATED_AT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'BETWEEN', 'EQ', 'LOE', 'GT'],
    componentType: 'date'
  },
  UPDATED_BY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  FILLED_BY_OPERATOR: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  PRIORITY_LANGUAGE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  OTHER_LANGUAGE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  PRIORITY_COUNTRY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  OTHER_COUNTRIES: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  COMMERCIAL_WEB_SITE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  UNSURE_TYPE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  BLACKLISTED: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  COUNTRY_OF_CONTACT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  POSTCODE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  CITY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  STREET: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  EMAIL: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  PHONE_NUMBER: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  CONTACT_FORM_LINK: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  NO_DETAILS_FOUND: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  NO_LANGUAGE_IDENTIFIED: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  MULTILANGUAGE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  NO_COUNTRY_IDENTIFIED: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  MULTI_NATIONAL: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  FACEBOOK_LINK: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  TWITTER_LINK: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  INSTAGRAM_LINK: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  LINKEDIN_LINK: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  PRIORITY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  COMPANY_NAME: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  }
};

export const IMAGES_TABLE_FIELDS_FILTER = {
  ID: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number'
  },
  DOMAIN: {
    selectorTypes: ['LIKE', 'IN', 'EQ', 'IS_NOT_NULL', 'IS_NULL', 'NOT_IN'],
    componentType: 'string'
  },
  COUNTRY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  TOTAL_SIGHTINGS: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number'
  },
  IDENTICAL_SIGHTINGS: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number'
  },
  DOMAIN_FLOW_STATUS: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  COMMERCIAL: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  PURSUABLE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  NOT_BLACKLISTED: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  CREATED_AT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'BETWEEN', 'EQ', 'LOE', 'GT'],
    componentType: 'date'
  },
  UPDATED_AT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'BETWEEN', 'EQ', 'LOE', 'GT'],
    componentType: 'date'
  },
  UPDATED_BY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  STATUS: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'status'
  },
  AGENCY: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  TLD: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  IMAGE_URL: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  USAGE_URL: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  ORIGINAL_IMAGE_FILE_NAME: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  REGISTERED_IMAGE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  UNIQUE_ID: {
    selectorTypes: [
      'IS_NOT_NULL',
      'IS_NULL',
      'BETWEEN',
      'EQ',
      'LOE',
      'GT',
      'NOT_IN',
      'IN'
    ],
    componentType: 'number'
  },
  BLACKLISTED: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'IS_TRUE', 'IS_FALSE'],
    componentType: 'boolean'
  },
  REGISTRATION_NUMBER: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  COMMENT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  EMAILS: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  DOWNLOADED_AT: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'BETWEEN', 'EQ', 'LOE', 'GT'],
    componentType: 'date'
  },
  PHOTOGRAPHER_NAME: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  },
  IMAGE_SOURCE: {
    selectorTypes: ['IS_NOT_NULL', 'IS_NULL', 'LIKE', 'EQ', 'IN', 'NOT_IN'],
    componentType: 'string'
  }
};

export const IMPORT_OPTIONS = [
  { title: 'IMAGES - NOT PURSUABLE', key: 'imagesNotPursuable' },
  { title: 'IMAGES - REGISTERED', key: 'imagesRegistered' },
  { title: 'DOMAINS - BLACKLISTED', key: 'domainsBlacklisted' }
];
